<template>
  <div class="modal" tabindex="-1" role="dialog" style="display:block!important" v-if="show_modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{title || 'Bist du sicher?'}}
          </h5>
        </div>
        <div class="modal-body" v-if="text">
          <p class="text-center"><span v-html="text"></span></p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-success" @click="_confirm()">Ja!</button>
          <button class="btn btn-danger" @click="_cancel()">Nein</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop" v-if="show_modal"></div>
</template>

<script>
export default {
  name: "ConfirmModal",
  data() {
    return {
      // Private variables
      resolvePromise: undefined,
      rejectPromise: undefined,
      show_modal: false,
      title: "",
      text: '',
    }
  },
  methods: {
    show(title, text) {
      this.title = title;
      this.text = text;
      this.show_modal = true;

      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.show_modal = false;
      this.resolvePromise(true)
    },
    _cancel() {
      this.show_modal = false;
      this.resolvePromise(false)
    },
  }
}
</script>

<style scoped>

</style>